'use client';

import {
  type BaseArtifactDto,
  BrowserScreenshotArtifactMetadataSchema,
} from '@terra/shared-contracts-artifact';
import { useArtifactsOptional } from '../ArtifactsProvider';
import { useBrowserToolCallArtifact } from './useBrowserToolCallArtifact';

const pickScreenshotArtifact = (
  artifacts: BaseArtifactDto[],
): BaseArtifactDto | null =>
  artifacts.find(
    (artifact) =>
      BrowserScreenshotArtifactMetadataSchema.safeParse(artifact.metadata)
        .success,
  ) ?? null;

export const useBrowserScreenshotArtifact = (
  toolCallId: string,
  { watch = false }: { watch?: boolean } = {},
): BaseArtifactDto | null => {
  const artifactFromTrace =
    useArtifactsOptional()?.getScreenshotByToolCallId(toolCallId) ?? null;
  const fetchedArtifact = useBrowserToolCallArtifact({
    toolCallId,
    enabled: !artifactFromTrace,
    pick: pickScreenshotArtifact,
    watch,
  });

  return artifactFromTrace ?? fetchedArtifact;
};
